import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/pbatch_run/customer_order_solo/');

const state = {
    ...current_module.state,
    columns: [
        {text: 'Title', value: 'title', sortable: true, filterable: true, divider: true,},
    ],
    options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['title'],
        sortDesc: [false],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        PCustomerOrderSelectTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}